import React, { useContext } from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { ThemeContext } from "../context/ThemeContext";
import Nav from './layouts/nav';
import Footer from './layouts/Footer';
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Registration from "./pages/Registration";
import PrivateRoute from './layouts/PrivateRoute';
import ForexTrades from "./pages/ForexTrades";
import CryptoTrades from "./pages/CryptoTrades";
import KYC from "./pages/KYC";
import BankAccounts from "./pages/BankAccounts";
import Deposit from "./pages/Deposit";
import Withdraw from "./pages/Withdraw";
import Transactions from "./pages/Transactions";
import GoldTrades from "./pages/GoldTrades";
import ChangePassword from "./pages/ChangePassword";
import Referrals from "./pages/Referrals";
// ... other imports

const Markup = () => {
    return (
        <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Registration />} />
            
            {/* Protected Routes */}
            <Route element={<PrivateRoute><PrivateLayout /></PrivateRoute>}>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/trades/forex" element={<ForexTrades />} />
                <Route path="/trades/crypto" element={<CryptoTrades />} />
                <Route path="/kyc" element={<KYC />} />
                <Route path="/bank-accounts" element={<BankAccounts />} />
                <Route path="/deposit" element={<Deposit />} />
                <Route path="/withdraw" element={<Withdraw />} />
                <Route path="/transactions" element={<Transactions />} />
                <Route path="/trades/gold" element={<GoldTrades />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/referrals" element={<Referrals />} />
                {/* Add other protected routes here */}
            </Route>

            {/* Catch all */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
    );
};

// Layout wrapper for authenticated routes
const PrivateLayout = () => {
    const { menuToggle } = useContext(ThemeContext);
    
    return (
        <div id="main-wrapper" className={`show ${menuToggle ? "menu-toggle" : ""}`}>
            <Nav />
            
            {/* Global Ticker Tapes */}
            <div className="content-body">
                <div className="container-fluid px-0">
                    {/* Forex Ticker */}
                    <div className="row gx-0">
                        <div className="col-12">
                            <div className="card rounded-0 border-0">
                                <div className="card-body p-0">
                                    <iframe
                                        src="https://www.tradingview-widget.com/embed-widget/ticker-tape/?locale=en#%7B%22symbols%22%3A%5B%7B%22proName%22%3A%22FX%3AEURUSD%22%2C%22title%22%3A%22EUR%2FUSD%22%7D%2C%7B%22proName%22%3A%22FX%3AGBPUSD%22%2C%22title%22%3A%22GBP%2FUSD%22%7D%2C%7B%22proName%22%3A%22FX%3AUSDJPY%22%2C%22title%22%3A%22USD%2FJPY%22%7D%2C%7B%22proName%22%3A%22FX%3AAUDUSD%22%2C%22title%22%3A%22AUD%2FUSD%22%7D%2C%7B%22proName%22%3A%22FX%3AUSDCAD%22%2C%22title%22%3A%22USD%2FCAD%22%7D%2C%7B%22proName%22%3A%22FX%3AUSDCHF%22%2C%22title%22%3A%22USD%2FCHF%22%7D%5D%2C%22showSymbolLogo%22%3Atrue%2C%22colorTheme%22%3A%22light%22%2C%22isTransparent%22%3Afalse%2C%22displayMode%22%3A%22adaptive%22%2C%22width%22%3A%22100%25%22%2C%22height%22%3A46%7D"
                                        style={{
                                            width: "100%",
                                            height: "46px",
                                            border: "none"
                                        }}
                                        allowTransparency="true"
                                        frameBorder="0"
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Crypto Ticker */}
                    <div className="row gx-0">
                        <div className="col-12">
                            <div className="card rounded-0 border-0">
                                <div className="card-body p-0">
                                    <iframe
                                        src="https://www.tradingview-widget.com/embed-widget/ticker-tape/?locale=en#%7B%22symbols%22%3A%5B%7B%22proName%22%3A%22BINANCE%3ABTCUSDT%22%2C%22title%22%3A%22BTC%2FUSDT%22%7D%2C%7B%22proName%22%3A%22BINANCE%3AETHUSDT%22%2C%22title%22%3A%22ETH%2FUSDT%22%7D%2C%7B%22proName%22%3A%22BINANCE%3ABNBUSDT%22%2C%22title%22%3A%22BNB%2FUSDT%22%7D%2C%7B%22proName%22%3A%22BINANCE%3AADAUSDT%22%2C%22title%22%3A%22ADA%2FUSDT%22%7D%2C%7B%22proName%22%3A%22BINANCE%3AXRPUSDT%22%2C%22title%22%3A%22XRP%2FUSDT%22%7D%2C%7B%22proName%22%3A%22BINANCE%3ASOLUSDT%22%2C%22title%22%3A%22SOL%2FUSDT%22%7D%5D%2C%22showSymbolLogo%22%3Atrue%2C%22colorTheme%22%3A%22light%22%2C%22isTransparent%22%3Afalse%2C%22displayMode%22%3A%22adaptive%22%2C%22width%22%3A%22100%25%22%2C%22height%22%3A46%7D"
                                        style={{
                                            width: "100%",
                                            height: "46px",
                                            border: "none"
                                        }}
                                        allowTransparency="true"
                                        frameBorder="0"
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="container-fluid">
                        <Outlet />
                    </div>
                </div>
            </div>
            <Footer />

            <style jsx>{`
                .content-body {
                    margin-left: ${menuToggle ? "0.9375rem" : "17.1875rem"};
                    transition: all .2s ease;
                }
                @media (max-width: 767px) {
                    .content-body {
                        margin-left: 0;
                    }
                }
            `}</style>
        </div>
    );
};

export default Markup;